import React, { FunctionComponent } from 'react'

export const UpdatePrint: FunctionComponent = () => (
    <p style={{ color: 'black' }}>Print</p>
)
